<section class="bg-section-wrapper">
  <!-- <div class="bg-section"></div> -->
  <div class="basic-table-layout single-page">
    <div class="">
      <div class="table-header-custom">
        <div class="employee-img-wrapper">
          <img src="assets/images/property.png" class="project-img" *ngIf="!project.projectImage" />
          <img [src]="project.projectImage" class="project-img" *ngIf="project.projectImage" />
        </div>
        <!-- <ng-container *ngIf="loading">
                    <clr-spinner>Loading project</clr-spinner>
                </ng-container> -->
        <ng-container>
          <div class="w-100">
            <div class="general-info">
              <div class="row">
                <div class="col-12">
                  <div>
                    <h3 class="m-0">
                      <div class="col-12">
                        <b class="mr-1">{{ project?.name }}</b>
                        <ng-container class="mr-1" *ngIf="isManager || isAdmin">
                          <ng-container *ngIf="project.sheetId"><a [href]="sheet" target="_blank"
                              class="data-sheet ms-2"><img src="assets/images/excel.svg"
                                class="icon-img" /></a></ng-container>
                          <ng-container *ngIf="project.folderId"><a [href]="folder" target="_blank"
                              class="data-sheet ms-2"><img src="assets/images/google-drive.svg"
                                class="icon-img" /></a></ng-container>
                        </ng-container>
                        <ng-container class="mr-1">
                          <h5 class="sml-extra-heading badge" [ngClass]="statusClasses[project.projectStatus]">
                            <b>{{ project.projectStatus }}</b>
                          </h5>
                        </ng-container>
                      </div>
                    </h3>
                  </div>
                  <!-- <h5 class="m-0">{{ project?.projectId }}</h5> -->
                  <div class="col-12">
                    <span class="m-0">{{ project?.companyAssignmentId }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="general-info-details row mt-2 m-0">
        <!-- <div class="userprofileBadge">
          <p class="sml-txt">Project Status</p>
          <ng-container>
            <h5 class="sml-extra-heading badge" [ngClass]="statusClasses[project.projectStatus]">
              <b>{{ project.projectStatus }}</b>
            </h5>
          </ng-container>
        </div> -->
        <div class="userprofileBadge">
          <p class="sml-txt">Project Purpose</p>
          <h5 class="sml-extra-heading">
            <b> {{ project.projectPurpose }} </b>
          </h5>
        </div>
        <!-- <div class="userprofileBadge">
          <p class="sml-txt">Start Date</p>
          <ng-container *ngIf="project.startDate">
            <h5 class="sml-extra-heading">
              <b> {{ project.startDate | date: 'MM/dd/yyyy' }} </b>
            </h5>
          </ng-container>
        </div>
        <div class="userprofileBadge">
          <p class="sml-txt">Due Date</p>
          <ng-container *ngIf="project.dueDate">
            <h5 class="sml-extra-heading">
              <b> {{ project.dueDate | date: 'MM/dd/yyyy' }} </b>
            </h5>
          </ng-container>
        </div> -->
        <div class="userprofileBadge">
          <p class="sml-txt">Date</p>
          <ng-container *ngIf="project.dueDate && project.startDate">
            <h5 class="sml-extra-heading">
              <b> {{ project.startDate | date: 'MM/dd/yyyy' }} - {{ project.dueDate | date: 'MM/dd/yyyy' }} </b>
            </h5>
          </ng-container>
        </div>
        <!-- <div class="userprofileBadge">
          <p class="sml-txt">Type</p>
          <h5 class="sml-extra-heading">
            <b>{{ project.projectType }}</b>
          </h5>
        </div> -->
        <div class="userprofileBadge" *ngIf="(isAdmin || isManager) && projectClient && projectClient?.customer?.name">
          <p class="sml-txt">Project Client</p>
          <h5 class="sml-extra-heading"><b>{{ projectClient?.customer?.name || '' }}</b></h5>
        </div>
        <div class="userprofileBadge"
          *ngIf="(isAdmin || isManager) && projectClient && projectClient?.clientFileNumber">
          <p class="sml-txt">Client File Number</p>
          <h5 class="sml-extra-heading">
            <b>{{ projectClient?.clientFileNumber || '' }}</b>
          </h5>
        </div>
        <div class="userprofileBadge">
          <p class="sml-txt">Account Manager</p>
          <app-user-profile [user]="project.accountManager"></app-user-profile>
        </div>
        <div class="userprofileBadge">
          <p class="sml-txt">Project Manager</p>
          <app-user-profile [user]="project.projectManager"></app-user-profile>
        </div>

      </div>
    </div>
    <div class="global-tabs">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <a class="nav-link" id="t1-tab" data-bs-toggle="tab" data-bs-target="#t1" type="button" role="tab"
            aria-controls="t1" aria-selected="true" [routerLink]="['/projects', project.id]"
            [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">Details
          </a>
        </li>
        <li class="nav-item" role="presentation">
          <a class="nav-link" id="t3-tab" data-bs-toggle="tab" data-bs-target="#t5" role="tab" aria-controls="t5"
            aria-selected="false" [routerLink]="['tasks']" [routerLinkActive]="'active'">Tasks
          </a>
        </li>
        
        <li class="nav-item" role="presentation">
          <a class="nav-link" id="t8-tab" data-bs-toggle="tab" data-bs-target="#t8" role="tab" aria-controls="t8"
            aria-selected="false" [routerLink]="['data-analytics']" [routerLinkActive]="'active'">Data and Analytics
          </a>
        </li>
        <li class="nav-item" role="presentation">
          <a class="nav-link" id="t3-tab" data-bs-toggle="tab" data-bs-target="#t3" role="tab" aria-controls="t3"
            aria-selected="false" [routerLink]="['summary']" [routerLinkActive]="'active'">Summary
          </a>
        </li>

        <!-- <ng-container *ngIf="isControlTower || isAdmin || isManager">
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="t3-tab" data-bs-toggle="tab" data-bs-target="#t5" role="tab" aria-controls="t5"
              aria-selected="false" [routerLink]="['folder']" [routerLinkActive]="'active'">Folder
            </a>
          </li>
        </ng-container> -->
        <!-- <li class="nav-item" role="presentation">
          <a class="nav-link" id="t3-tab" data-bs-toggle="tab" data-bs-target="#t3" role="tab" aria-controls="t3"
            aria-selected="false" [routerLink]="['fee']" [routerLinkActive]="'active'" >Fee
          </a>
        </li> -->
        <ng-container *ngIf="isAdmin || isManager">
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="t3-tab" data-bs-toggle="tab" data-bs-target="#t3" role="tab" aria-controls="t3"
              aria-selected="false" [routerLink]="['financials']" [routerLinkActive]="'active'">Accounting
            </a>
          </li>
        </ng-container>
        <ng-container *ngIf="shouldDisplayFeeTab">
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="t3-tab" data-bs-toggle="tab" data-bs-target="#t3" role="tab" aria-controls="t3"
              aria-selected="false" [routerLink]="['fee']" [routerLinkActive]="'active'">Fee
            </a>
          </li>
        </ng-container>
        <ng-container>
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="t3-tab" data-bs-toggle="tab" data-bs-target="#t3" role="tab" aria-controls="t3"
              aria-selected="false" [routerLink]="['report-writing']" [routerLinkActive]="'active'">Report
            </a>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>

  <div class="global-tabs-outer-wrapper">
    <router-outlet></router-outlet>
  </div>
</section>